import { useQuery } from 'react-query';
import dealService from 'resources/deal/deal.service';
import milestoneService from 'resources/milestone/milestone.service';

const getDealsWithMilestones = async (companyId) => {
  if (!companyId) {
    return null;
  }

  const deals = await dealService.getDealsByCompanyId(companyId, { onlyActive: true });
  const dealIds = deals.map((deal) => deal.id);
  const milestones = await milestoneService.getMilestonesByDealIds(dealIds);

  return deals.map((deal) => ({
    ...deal,
    milestones: milestones.filter((milestone) => milestone.deal_id === deal.id),
  }));
};

export default function useGetDealsWithMilestones(companyId, queryOptions) {
  return useQuery(
    ['deals-with-milestones', companyId],
    () => getDealsWithMilestones(companyId),
    queryOptions,
  );
}